import { Dialog, styled } from "@mui/material";

export const BaseAlertModalWrapper = styled(Dialog)(() => {
	return {
		"& h2": {
			fontFamily: "Inter",
			fontWeight: 700,
			fontSize: 30,
			lineHeight: "normal",
			textAlign: "center",
			overflow: "hidden",
			whiteSpace: "nowrap",
			textOverflow: "ellipsis",
			padding: "var(--basic-padding)",
		},
		"& .modal-content": {
			padding: "var(--basic-padding)",
		},
	};
});
